module.exports = __webpack_public_path__ + "img/3.601d692d.jpg";